import { gql } from '@apollo/client';

export const UPDATE_NE_MAN = gql`
  mutation updateNeMan($neMan: NeManInput!) {
    updateNeMan(neMan: $neMan) {
      id
    }
  }
`;
